module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    attrs: {
      "type": "hidden",
      "id": _vm.id,
      "readonly": "readonly"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ce8a7b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/range-slider.vue
// module id = 494
// module chunks = 1